module.exports = __webpack_public_path__ + "img/hardyClub3.acadb09e.png";